import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import api from '../api';

export default function Students() {
  const [students, setStudents] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get('/students', { params: { search } });
      setStudents(res.data);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, [search]);

  const deleteStudent = async (id) => {
    if (!window.confirm('Delete this student?')) return;
    await api.delete(`/students/${id}`);
    load();
  };

  return (
    <Layout title="Students">
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">🎓 All Students ({students.length})</h3>
          <button className="btn btn-primary" onClick={() => navigate('/admin/students/add')}>
            ➕ Add Student
          </button>
        </div>

        <div className="filters-bar">
          <input
            type="text"
            placeholder="Search by name, CNIC, contact..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ minWidth: 280 }}
          />
        </div>

        {loading ? (
          <div className="text-center" style={{ padding: 40, color: '#718096' }}>Loading...</div>
        ) : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Photo</th>
                  <th>Name</th>
                  <th>Father Name</th>
                  <th>CNIC</th>
                  <th>Room</th>
                  <th>Institute</th>
                  <th>Contact</th>
                  <th>Monthly Fee</th>
                  <th>Status</th>
                  <th>Portal Account</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {students.length === 0 ? (
                  <tr><td colSpan={11} className="text-center" style={{ padding: 30, color: '#718096' }}>No students found</td></tr>
                ) : students.map(s => (
                  <tr key={s._id}>
                    <td>
                      {s.photo ? (
                        <img
                          src={s.photo.startsWith('/') ? s.photo : `/uploads/${s.photo}`}
                          alt={s.name}
                          style={{ width: 36, height: 36, borderRadius: 6, objectFit: 'cover', border: '1px solid #e2e8f0' }}
                          onError={e => { e.target.style.display = 'none'; }}
                        />
                      ) : (
                        <div style={{ width: 36, height: 36, borderRadius: 6, background: '#ebf8ff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>
                          👤
                        </div>
                      )}
                    </td>
                    <td><strong>{s.name}</strong></td>
                    <td>{s.fatherName}</td>
                    <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{s.cnicNo}</td>
                    <td>
                      <span className="badge badge-info">{s.room}</span>
                    </td>
                    <td style={{ fontSize: 12 }}>{s.institute}</td>
                    <td style={{ fontSize: 12 }}>{s.contactNo}</td>
                    <td>PKR {(s.monthlyFee || 0).toLocaleString()}</td>
                    <td>
                      <span className={`badge ${s.status === 'Active' ? 'badge-success' : 'badge-secondary'}`}>
                        {s.status}
                      </span>
                    </td>
                    <td>{s.account ? <div><strong style={{ fontSize: 12 }}>@{s.account.username}</strong><span className={`badge ${s.account.status === 'Active' ? 'badge-success' : 'badge-secondary'}`} style={{ marginLeft: 6 }}>{s.account.status}</span></div> : <span className="badge badge-warning">No login</span>}</td>
                    <td>
                      <div className="flex gap-10">
                        <button className="btn btn-outline btn-sm" onClick={() => navigate(`/admin/students/${s._id}`)}>
                          👁 View
                        </button>
                        <button className="btn btn-warning btn-sm" onClick={() => navigate(`/admin/students/${s._id}/edit`)}>
                          ✏ Edit
                        </button>
                        <button className="btn btn-danger btn-sm" onClick={() => deleteStudent(s._id)}>
                          🗑 Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Layout>
  );
}
